import styles from "./PromotionCardGroupMobile.module.css";
import { PromotionCardDataType } from "../../../interfaces/PromotionCard";
import useHintStore from "../../../store/hintStateStore";
import { useState } from "react";
import { getGeneralImage, generateStyleClasses } from "../../../helpers/commonFunctions";
import PromotionCardMobile from "./PromotionCardMobile";

export default function PromotionCardGroupMobile({
  data,
}: {
  data: PromotionCardDataType;
}) {
  const title = data.title;
  const packages = data.promotionalPackages;
  const description = data.description;
  const { setOpen } = useHintStore();
  const [isDisabled, setIsDisabled] = useState(false);
  return (
    <>
      <div
        className={`vas-card vas-p-3`}
        style={{
          borderColor: data?.borderColor,
          zIndex: "7",
        }}
      >
        <div className="vas-d-flex vas-gap-2 vas-align-items-start vas-justify-content-center vas-mb-3">
          {title?.icon && (
            <img
              className="vas vas-mt-1"
              src={getGeneralImage(title?.icon)}
              alt=""
              width={30}
              height={30}
            />
          )}
          <div className="vas-w-100">
            <div
              className="vas-text-20 vas-fw-bold vas-w-100"
              style={{ color: title?.textColor }}
            >
              {title?.text}
            </div>

            <div className="vas-d-flex vas-flex-column vas-gap-3 vas-my-2">
              <span
                className={`vas-text-13 vas-text-muted vas-d-block ${styles.info_description}`}
                style={{ color: description?.textColor }}
              >
                {description?.text}
              </span>
              {description?.hint && (
                <div
                  className={`${generateStyleClasses(
                    description?.hint?.style
                  )} vas-text-12`}
                  style={{
                    color: description?.hint?.textColor,
                  }}
                >
                  <span
                    className="pointerCursor"
                    onClick={() => setOpen(true, description?.hint?.link)}
                  >
                    {description?.hint?.text}
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="vas-w-100">
          <div
            className="vas-fw-bold vas-text-15"
            style={{ color: packages?.titleColor }}
          >
            {packages?.title}
          </div>
          <div
            className={`vas-d-flex vas-gap-2 vas-position-relative ${
              packages?.data?.length === 3
                ? "vas-justify-content-center vas-align-items-center"
                : ""
            } ${styles.card_holder}`}
          >
            {packages &&
              packages.data.map((item, idx) => {
                return (
                  <PromotionCardMobile
                    pkg={item}
                    setIsDisabled={setIsDisabled}
                    isDisabled={isDisabled}
                    key={idx}
                  />
                );
              })}
          </div>
          <div
            className={`vas-mt-3 vas-mb-1 vas-fw-bold vas-text-20 ${styles.price_holder}`}
            style={{ color: packages?.shownPriceColor }}
          >
            {packages?.shownPrice}
          </div>
        </div>
      </div>
    </>
  );
}
